// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dashboard home + sub-pages: shared layout */
.dashboard-home,
.dashboard-subpage {
  padding: 0;
  min-height: calc(100vh - 60px);
  width: 100%;
  display: flex;
  flex-direction: column;
}

.dashboard-hero__breadcrumb {
  margin: 0 0 0.35rem;
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.85);
}

.dashboard-hero__breadcrumb a {
  color: rgba(255, 255, 255, 0.95);
  text-decoration: none;
}

.dashboard-hero__breadcrumb a:hover {
  text-decoration: underline;
}

.dashboard-content-inner {
  padding: 1.25rem;
  overflow-x: auto;
}

.dashboard-content-inner .data-table th,
.dashboard-content-inner .data-table td {
  padding: 0.85rem 1.25rem;
}

.dashboard-content-inner .data-table th {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

/* Hero: gradient header with depth */
.dashboard-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  padding: 5rem 1.75rem;
  background: linear-gradient(135deg, #0f766e 0%, #0d9488 40%, #14b8a6 70%, #5eead4 100%);
  border-radius: 0 0 20px 20px;
  margin-bottom: 1.75rem;
  box-shadow: 0 4px 20px rgba(15, 118, 110, 0.25);
  position: relative;
  overflow: hidden;
}

.dashboard-hero::before {
  content: "";
  position: absolute;
  top: -50%;
  right: -20%;
  width: 60%;
  height: 200%;
  background: radial-gradient(ellipse, rgba(255,255,255,0.12) 0%, transparent 70%);
  pointer-events: none;
}

.dashboard-hero__text {
  flex: 1 1;
  min-width: 0;
  position: relative;
  z-index: 1;
}

.dashboard-hero__greeting {
  margin: 0 0 0.35rem;
  font-size: 0.95rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
  letter-spacing: 0.02em;
}

.dashboard-hero__title {
  margin: 0 0 0.4rem;
  font-size: 2rem;
  font-weight: 800;
  color: #fff;
  letter-spacing: -0.02em;
  line-height: 1.2;
}

.dashboard-hero__subtitle {
  margin: 0;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.85);
  max-width: 420px;
}

.dashboard-hero__icon {
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  position: relative;
  z-index: 1;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Home hero enhancements */
.home-hero__meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem 1.25rem;
  margin-bottom: 0.25rem;
}

.home-hero__date {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.75);
  font-weight: 500;
}

.home-hero__icons {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
}

.home-hero__icon--chart {
  background: rgba(255, 255, 255, 0.25) !important;
  border: 1px solid rgba(255, 255, 255, 0.35);
}

.home-hero__stats-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.75rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.home-hero__stats-pill i {
  font-size: 0.65rem;
  color: #86efac;
  animation: pulse-dot 2s ease-in-out infinite;
}

@keyframes pulse-dot {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

/* Body */
.dashboard-body {
  flex: 1 1;
  padding: 0 1.5rem 1.75rem;
}

/* Metric sections */
.home-metrics-section {
  margin-bottom: 2rem;
}

.home-metrics-section:last-of-type {
  margin-bottom: 1.75rem;
}

.home-metrics-section__title {
  margin: 0 0 1rem;
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-muted, #64748b);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e2e8f0;
}

/* Metric cards: modern with hover */
.dashboard-metrics {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1.25rem;
  margin-bottom: 0;
}

.home-metrics-section .dashboard-metrics {
  margin-bottom: 0;
}

.dashboard-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  padding: 1.5rem;
  position: relative;
  border: 1px solid var(--border);
  transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;
  overflow: hidden;
}

.dashboard-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.1);
  border-color: rgba(15, 118, 110, 0.25);
}

/* Home metric cards – accent strip */
.home-card {
  border-radius: 14px;
  padding: 1.5rem 1.5rem 1.5rem 1.6rem;
}

.home-card--link {
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  display: block;
}

.home-card--link:hover {
  color: inherit;
}

.home-card__accent {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  opacity: 0.9;
  border-radius: 14px 0 0 14px;
}

.dashboard-card__label {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--text-muted);
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-right: 40px;

}

.dashboard-card__value {
  font-size: 1.7rem;
  font-weight: 800;
  color: var(--text);
  letter-spacing: -0.03em;
  line-height: 1.2;
}

.home-card .dashboard-card__value {
  font-size: 1.6rem;
}

.home-card__currency {
  font-size: 0.65em;
  font-weight: 600;
  opacity: 0.85;
  margin-left: 0.15rem;
}

.dashboard-card__icon {
  position: absolute;
  top: 1.25rem;
  right: 1.25rem;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1.2rem;
  opacity: 0.95;
}

.home-card__icon {
  opacity: 0.92;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

/* Activity section */
.dashboard-activity-section {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--border);
  overflow: hidden;
}

.dashboard-activity-header {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 1.15rem 1.5rem;
  background: linear-gradient(180deg, #f8fafc 0%, #fff 100%);
  border-bottom: 1px solid var(--border);
}

/* Home activity header – enhanced */
.home-activity-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, #f0fdfa 0%, #f8fafc 100%);
  border-bottom: 1px solid #e2e8f0;
}

.home-activity-header__left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.home-activity-header__subtitle {
  margin: 0.2rem 0 0;
  font-size: 0.8rem;
  color: var(--text-muted);
  font-weight: 500;
}

.home-activity-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.home-activity-view-all {
  font-size: 0.875rem;
  font-weight: 500;
  color: #0f766e;
  text-decoration: none;
}

.home-activity-view-all:hover {
  text-decoration: underline;
}

.home-activity-refresh {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  font-size: 0.85rem;
  font-weight: 500;
  font-family: inherit;
  color: #0f766e;
  background: rgba(15, 118, 110, 0.1);
  border: 1px solid rgba(15, 118, 110, 0.25);
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
}

.home-activity-refresh:hover:not(:disabled) {
  background: rgba(15, 118, 110, 0.15);
  border-color: #0f766e;
}

.home-activity-refresh:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.home-activity-refresh i {
  font-size: 0.8rem;
}

.home-activity-error {
  padding: 0.85rem 1.5rem;
  background: #fef2f2;
  color: #b91c1c;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-bottom: 1px solid #fecaca;
}

.home-activity-loading,
.home-activity-empty {
  padding: 2rem 1.5rem;
  text-align: center;
  color: var(--text-muted, #64748b);
  font-size: 0.9rem;
}

.home-activity-loading i {
  margin-right: 0.5rem;
}

.dashboard-activity-header__icon {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.05rem;
  box-shadow: 0 2px 8px rgba(15, 118, 110, 0.3);
}

.dashboard-activity-header__title {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text);
}

.dashboard-activity-table-wrap {
  overflow-x: auto;
}

.dashboard-activity-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.dashboard-activity-table th,
.dashboard-activity-table td {
  padding: 1rem 1.5rem;
  text-align: left;
  border-bottom: 1px solid var(--border);
}

.dashboard-activity-table th {
  font-weight: 600;
  color: var(--text-muted);
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  background: #fafafa;
}

.home-activity-table th {
  background: #f8fafc;
  font-size: 0.72rem;
}

.dashboard-activity-table tbody tr:last-child td {
  border-bottom: none;
}

.dashboard-activity-table tbody tr {
  transition: background 0.15s;
}

.dashboard-activity-table tbody tr:hover {
  background: rgba(15, 118, 110, 0.04);
}

.home-activity-table tbody tr:nth-child(even) {
  background: #fafafa;
}

.home-activity-table tbody tr:nth-child(even):hover {
  background: rgba(15, 118, 110, 0.05) !important;
}

.activity-cell {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.activity-cell__icon {
  color: var(--primary);
  font-size: 0.85rem;
}

.home-activity-cell {
  font-weight: 500;
}

.activity-cell__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #0f766e;
  flex-shrink: 0;
}

.home-activity-sr {
  color: var(--text-muted);
  font-weight: 600;
  font-size: 0.85rem;
}

.home-activity-ip {
  font-family: ui-monospace, monospace;
  font-size: 0.85rem;
  padding: 0.2rem 0.5rem;
  background: #f1f5f9;
  border-radius: 6px;
  color: #475569;
}

.home-activity-datetime {
  font-size: 0.875rem;
  color: var(--text-muted);
}

@media (max-width: 1200px) {
  .dashboard-metrics {
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  }
}

@media (max-width: 768px) {
  .dashboard-hero {
    flex-direction: column;
    align-items: flex-start;
    padding: 1.5rem 1.25rem;
    border-radius: 0 0 16px 16px;
  }

  .home-hero__icons {
    width: 100%;
    justify-content: space-between;
  }

  .dashboard-hero__title {
    font-size: 1.6rem;
  }

  .dashboard-hero__icon {
    align-self: flex-end;
  }

  .dashboard-body {
    padding: 0 1rem 1.25rem;
  }

  .dashboard-metrics {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .dashboard-card {
    padding: 1.25rem;
  }

  .home-activity-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .home-activity-refresh {
    align-self: stretch;
    justify-content: center;
  }
}

/* Homepage: keep the green banner fully visible (not clipped by the scroll pane) */
.dashboard-main.dashboard-home {
  padding: 0;
  overflow: visible;
}

.dashboard-home .home-hero {
  margin: 1rem 1.25rem 1.5rem;
  padding: 1.75rem 1.75rem;
  border-radius: 16px;
  overflow: hidden;
}

@media (max-width: 768px) {
  .dashboard-home .home-hero {
    margin: 0.75rem 0.85rem 1.15rem;
    padding: 1.35rem 1.25rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Home/Homepage.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;;EAEE,UAAU;EACV,8BAA8B;EAC9B,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,qBAAqB;EACrB,uFAAuF;EACvF,4BAA4B;EAC5B,sBAAsB;EACtB,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gFAAgF;EAChF,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,0BAA0B;EAC1B,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,yCAAyC;AAC3C;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gDAAgD;EAChD,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,oCAAoC;EACpC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA,SAAS;AACT;EACE,SAAO;EACP,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,+BAA+B;EAC/B,8DAA8D;EAC9D,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;;AAEpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,0DAA0D;EAC1D,sCAAsC;AACxC;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,mCAAmC;EACnC,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gCAAgC;AAClC;;AAEA;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;AACF;;AAEA,mFAAmF;AACnF;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,+BAA+B;IAC/B,wBAAwB;EAC1B;AACF","sourcesContent":["/* Dashboard home + sub-pages: shared layout */\n.dashboard-home,\n.dashboard-subpage {\n  padding: 0;\n  min-height: calc(100vh - 60px);\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.dashboard-hero__breadcrumb {\n  margin: 0 0 0.35rem;\n  font-size: 0.8rem;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.dashboard-hero__breadcrumb a {\n  color: rgba(255, 255, 255, 0.95);\n  text-decoration: none;\n}\n\n.dashboard-hero__breadcrumb a:hover {\n  text-decoration: underline;\n}\n\n.dashboard-content-inner {\n  padding: 1.25rem;\n  overflow-x: auto;\n}\n\n.dashboard-content-inner .data-table th,\n.dashboard-content-inner .data-table td {\n  padding: 0.85rem 1.25rem;\n}\n\n.dashboard-content-inner .data-table th {\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n/* Hero: gradient header with depth */\n.dashboard-hero {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.5rem;\n  padding: 5rem 1.75rem;\n  background: linear-gradient(135deg, #0f766e 0%, #0d9488 40%, #14b8a6 70%, #5eead4 100%);\n  border-radius: 0 0 20px 20px;\n  margin-bottom: 1.75rem;\n  box-shadow: 0 4px 20px rgba(15, 118, 110, 0.25);\n  position: relative;\n  overflow: hidden;\n}\n\n.dashboard-hero::before {\n  content: \"\";\n  position: absolute;\n  top: -50%;\n  right: -20%;\n  width: 60%;\n  height: 200%;\n  background: radial-gradient(ellipse, rgba(255,255,255,0.12) 0%, transparent 70%);\n  pointer-events: none;\n}\n\n.dashboard-hero__text {\n  flex: 1;\n  min-width: 0;\n  position: relative;\n  z-index: 1;\n}\n\n.dashboard-hero__greeting {\n  margin: 0 0 0.35rem;\n  font-size: 0.95rem;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.9);\n  letter-spacing: 0.02em;\n}\n\n.dashboard-hero__title {\n  margin: 0 0 0.4rem;\n  font-size: 2rem;\n  font-weight: 800;\n  color: #fff;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n}\n\n.dashboard-hero__subtitle {\n  margin: 0;\n  font-size: 0.9rem;\n  color: rgba(255, 255, 255, 0.85);\n  max-width: 420px;\n}\n\n.dashboard-hero__icon {\n  flex-shrink: 0;\n  width: 56px;\n  height: 56px;\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(8px);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n  position: relative;\n  z-index: 1;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n/* Home hero enhancements */\n.home-hero__meta {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.75rem 1.25rem;\n  margin-bottom: 0.25rem;\n}\n\n.home-hero__date {\n  font-size: 0.8rem;\n  color: rgba(255, 255, 255, 0.75);\n  font-weight: 500;\n}\n\n.home-hero__icons {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-shrink: 0;\n  position: relative;\n  z-index: 1;\n}\n\n.home-hero__icon--chart {\n  background: rgba(255, 255, 255, 0.25) !important;\n  border: 1px solid rgba(255, 255, 255, 0.35);\n}\n\n.home-hero__stats-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.4rem 0.75rem;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #fff;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.home-hero__stats-pill i {\n  font-size: 0.65rem;\n  color: #86efac;\n  animation: pulse-dot 2s ease-in-out infinite;\n}\n\n@keyframes pulse-dot {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n}\n\n/* Body */\n.dashboard-body {\n  flex: 1;\n  padding: 0 1.5rem 1.75rem;\n}\n\n/* Metric sections */\n.home-metrics-section {\n  margin-bottom: 2rem;\n}\n\n.home-metrics-section:last-of-type {\n  margin-bottom: 1.75rem;\n}\n\n.home-metrics-section__title {\n  margin: 0 0 1rem;\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-muted, #64748b);\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n/* Metric cards: modern with hover */\n.dashboard-metrics {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 1.25rem;\n  margin-bottom: 0;\n}\n\n.home-metrics-section .dashboard-metrics {\n  margin-bottom: 0;\n}\n\n.dashboard-card {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  padding: 1.5rem;\n  position: relative;\n  border: 1px solid var(--border);\n  transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;\n  overflow: hidden;\n}\n\n.dashboard-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.1);\n  border-color: rgba(15, 118, 110, 0.25);\n}\n\n/* Home metric cards – accent strip */\n.home-card {\n  border-radius: 14px;\n  padding: 1.5rem 1.5rem 1.5rem 1.6rem;\n}\n\n.home-card--link {\n  text-decoration: none;\n  color: inherit;\n  cursor: pointer;\n  display: block;\n}\n\n.home-card--link:hover {\n  color: inherit;\n}\n\n.home-card__accent {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 4px;\n  opacity: 0.9;\n  border-radius: 14px 0 0 14px;\n}\n\n.dashboard-card__label {\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--text-muted);\n  margin-bottom: 0.5rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-right: 40px;\n\n}\n\n.dashboard-card__value {\n  font-size: 1.7rem;\n  font-weight: 800;\n  color: var(--text);\n  letter-spacing: -0.03em;\n  line-height: 1.2;\n}\n\n.home-card .dashboard-card__value {\n  font-size: 1.6rem;\n}\n\n.home-card__currency {\n  font-size: 0.65em;\n  font-weight: 600;\n  opacity: 0.85;\n  margin-left: 0.15rem;\n}\n\n.dashboard-card__icon {\n  position: absolute;\n  top: 1.25rem;\n  right: 1.25rem;\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-size: 1.2rem;\n  opacity: 0.95;\n}\n\n.home-card__icon {\n  opacity: 0.92;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n}\n\n/* Activity section */\n.dashboard-activity-section {\n  background: #fff;\n  border-radius: 14px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  border: 1px solid var(--border);\n  overflow: hidden;\n}\n\n.dashboard-activity-header {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  padding: 1.15rem 1.5rem;\n  background: linear-gradient(180deg, #f8fafc 0%, #fff 100%);\n  border-bottom: 1px solid var(--border);\n}\n\n/* Home activity header – enhanced */\n.home-activity-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 1.25rem 1.5rem;\n  background: linear-gradient(135deg, #f0fdfa 0%, #f8fafc 100%);\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.home-activity-header__left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.home-activity-header__subtitle {\n  margin: 0.2rem 0 0;\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  font-weight: 500;\n}\n\n.home-activity-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.home-activity-view-all {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #0f766e;\n  text-decoration: none;\n}\n\n.home-activity-view-all:hover {\n  text-decoration: underline;\n}\n\n.home-activity-refresh {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  font-size: 0.85rem;\n  font-weight: 500;\n  font-family: inherit;\n  color: #0f766e;\n  background: rgba(15, 118, 110, 0.1);\n  border: 1px solid rgba(15, 118, 110, 0.25);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.2s, border-color 0.2s;\n}\n\n.home-activity-refresh:hover:not(:disabled) {\n  background: rgba(15, 118, 110, 0.15);\n  border-color: #0f766e;\n}\n\n.home-activity-refresh:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.home-activity-refresh i {\n  font-size: 0.8rem;\n}\n\n.home-activity-error {\n  padding: 0.85rem 1.5rem;\n  background: #fef2f2;\n  color: #b91c1c;\n  font-size: 0.875rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  border-bottom: 1px solid #fecaca;\n}\n\n.home-activity-loading,\n.home-activity-empty {\n  padding: 2rem 1.5rem;\n  text-align: center;\n  color: var(--text-muted, #64748b);\n  font-size: 0.9rem;\n}\n\n.home-activity-loading i {\n  margin-right: 0.5rem;\n}\n\n.dashboard-activity-header__icon {\n  width: 46px;\n  height: 46px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.05rem;\n  box-shadow: 0 2px 8px rgba(15, 118, 110, 0.3);\n}\n\n.dashboard-activity-header__title {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.dashboard-activity-table-wrap {\n  overflow-x: auto;\n}\n\n.dashboard-activity-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.9rem;\n}\n\n.dashboard-activity-table th,\n.dashboard-activity-table td {\n  padding: 1rem 1.5rem;\n  text-align: left;\n  border-bottom: 1px solid var(--border);\n}\n\n.dashboard-activity-table th {\n  font-weight: 600;\n  color: var(--text-muted);\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  background: #fafafa;\n}\n\n.home-activity-table th {\n  background: #f8fafc;\n  font-size: 0.72rem;\n}\n\n.dashboard-activity-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.dashboard-activity-table tbody tr {\n  transition: background 0.15s;\n}\n\n.dashboard-activity-table tbody tr:hover {\n  background: rgba(15, 118, 110, 0.04);\n}\n\n.home-activity-table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.home-activity-table tbody tr:nth-child(even):hover {\n  background: rgba(15, 118, 110, 0.05) !important;\n}\n\n.activity-cell {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.activity-cell__icon {\n  color: var(--primary);\n  font-size: 0.85rem;\n}\n\n.home-activity-cell {\n  font-weight: 500;\n}\n\n.activity-cell__dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #0f766e;\n  flex-shrink: 0;\n}\n\n.home-activity-sr {\n  color: var(--text-muted);\n  font-weight: 600;\n  font-size: 0.85rem;\n}\n\n.home-activity-ip {\n  font-family: ui-monospace, monospace;\n  font-size: 0.85rem;\n  padding: 0.2rem 0.5rem;\n  background: #f1f5f9;\n  border-radius: 6px;\n  color: #475569;\n}\n\n.home-activity-datetime {\n  font-size: 0.875rem;\n  color: var(--text-muted);\n}\n\n@media (max-width: 1200px) {\n  .dashboard-metrics {\n    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .dashboard-hero {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 1.5rem 1.25rem;\n    border-radius: 0 0 16px 16px;\n  }\n\n  .home-hero__icons {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .dashboard-hero__title {\n    font-size: 1.6rem;\n  }\n\n  .dashboard-hero__icon {\n    align-self: flex-end;\n  }\n\n  .dashboard-body {\n    padding: 0 1rem 1.25rem;\n  }\n\n  .dashboard-metrics {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .dashboard-card {\n    padding: 1.25rem;\n  }\n\n  .home-activity-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .home-activity-refresh {\n    align-self: stretch;\n    justify-content: center;\n  }\n}\n\n/* Homepage: keep the green banner fully visible (not clipped by the scroll pane) */\n.dashboard-main.dashboard-home {\n  padding: 0;\n  overflow: visible;\n}\n\n.dashboard-home .home-hero {\n  margin: 1rem 1.25rem 1.5rem;\n  padding: 1.75rem 1.75rem;\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n@media (max-width: 768px) {\n  .dashboard-home .home-hero {\n    margin: 0.75rem 0.85rem 1.15rem;\n    padding: 1.35rem 1.25rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
